// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__YDfQM","info":"UpdateTermsInfo_info__1LJUk"};